import { useQuery } from "@tanstack/react-query"

import { NotificationsResponses } from "@tfg/types/endpoints/notifications"

import { httpClient } from "~/backend/axios.ts"

export const useListNotificationsQuery = () =>
  useQuery({
    queryKey: ["notifications"],
    queryFn: () =>
      httpClient
        .get<NotificationsResponses.Notification[]>("/notifications")
        .then((response) => response.data),
  })
